import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Card, CardContent, CardMedia } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 200,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function ViewProfile({ name, dp, description, profileLnk }) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    console.log("My dp", dp)
    return (
        <div>
            {/* <Button onClick={handleOpen}>View Profile</Button> */}
            <Button variant='contained' onClick={handleOpen} style={{ background: "#133F49", width: '150px' }}>View Profile</Button>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Card sx={style}>
                    <Box sx={{ display: 'flex', flexDirection: { md: 'row', xs: 'column' } }}>

                        <CardMedia
                            component="img"
                            sx={{ width: 250 }}
                            image={dp}
                            alt={name}
                        />
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, maxHeight: '40vh', wordWrap: 'normal',  overflow:'auto', scrollBehavior:'smooth' }}>
                            <CardContent sx={{ flex: 'auto', wordWrap: 'break-word'}} >
                                <Typography component="div" variant="h5">
                                    {name}
                                </Typography>
                                <Typography variant="subtitle1" color="text.secondary" component="div">
                                    {description}
                                </Typography>
                                <br/>
                                <Button variant='outlined' href={profileLnk} sx={{color:"#133F49"}}>Click to know More</Button>
                            </CardContent>
                        </Box>
                    </Box>
                </Card>
      
            </Modal>
        </div>
    );
}